module.exports = __webpack_public_path__ + "b6d5746430402ef5da5a20a78146da97.png";